import { getReportServiceAPIHost, getUserRegion } from '../../../../utils';

const buildReportServiceQuery = (endpoint, { body }) => {
    const clientName = getUserRegion();
    return {
        url: `${getReportServiceAPIHost()}${endpoint}?customer=${clientName}`,
        body,
    };
};

export default buildReportServiceQuery;
